import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import $api from '../api'
import { GetListDTO } from '../dto'
export interface AuthDTO {
  email: string
  password: string
}

export enum UsersOrderBy {
  NAME = 'name',
  REGISTERED_AT = 'registeredAt'
}
export enum OrderDirection {
  ASC = 'asc',
  DESC = 'desc',
}
export interface GetListUsersDto extends GetListDTO {
  orderBy?: UsersOrderBy
  orderDirection?: OrderDirection
}

export interface User {
  _id: string
  name: string
  email: string
  city?: string
  businessType?: string
  identifier?: string
  validatedAt?: number
  bannedAt?: number
  registeredAt?: number
  deleteRequestedAt?: number
  onlineUntil?: number
}

type UserEmail = string
interface State {
  users: Record<UserEmail, User>
  totalUsersCount: number
}

export interface IdDTO {
  id: string
}

export interface RegistrationDTO extends AuthDTO {
  name: string
  city: string;
  businessType: string;
}

export const initialState: State = {
  users: {},
  totalUsersCount: 0,
}

interface CreateUserResponse {
  user: User
  auth: {
    token: string
  }
}

export interface GetUsersResponse {
  users: User[];
  totalCount: number;
}

export const attemptCreateUser = createAsyncThunk<CreateUserResponse, RegistrationDTO>(
  'users/registration',
  async (payload) => {
    const response = await $api.post('user/registration', payload)
    return response.data
  },
)

export const attemptValidate = createAsyncThunk<void, string>(
  'users/validate',
  async (id) => {
    await $api.post(`users/${id}/validate`)
  },
)

export const attemptBan = createAsyncThunk<void, string>('users/ban', async (id) => {
  await $api.post(`users/${id}/ban`)
})

export const attemptDelete = createAsyncThunk<void, string>('users/delete', async (id) => {
  await $api.post(`users/${id}/delete`)
})

export const attemptUnban = createAsyncThunk<void, string>('users/unban', async (id) => {
  await $api.post(`users/${id}/unban`)
})

export const attemptGetUsers = createAsyncThunk<GetUsersResponse, GetListUsersDto>(
  'users/list',
  async (payload) => {
    const response = await $api.post('users/list', payload)
    return response.data
  },
)

export const usersReducer = createSlice({
  name: 'users',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(attemptGetUsers.fulfilled, (state, { payload }) => {
      state.users = {};
      payload.users.forEach((user) => {
        state.users[user._id] = user
      })
      state.totalUsersCount = payload.totalCount
    })
    .addCase(attemptGetUsers.rejected, (state, action) => {
      state.users = {};
      state.totalUsersCount = 0;
    })

    builder.addCase(attemptCreateUser.fulfilled, (state, { payload }) => {
      state.users[payload.user._id] = payload.user
    })

    builder.addCase(attemptValidate.fulfilled, (state, action) => {
      state.users[action.meta.arg].validatedAt = Date.now()
    })

    builder.addCase(attemptBan.fulfilled, (state, action) => {
      state.users[action.meta.arg].bannedAt = Date.now()
    })

    builder.addCase(attemptDelete.fulfilled, (state, action) => {
      delete state.users[action.meta.arg]
    })

    builder.addCase(attemptUnban.fulfilled, (state, action) => {
      delete state.users[action.meta.arg].bannedAt
    })
  },
})

export const {} = usersReducer.actions
export default usersReducer.reducer
